import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=538b0b14&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=538b0b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b0b14",
  null
  
)

export default component.exports